import { ComplementPoPdfVer } from '../../intervenant/models/complementPoPdfVer.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class InfosGenerationAudit {
    static jsonMap = {
        idEntrepriseList: { key: 'idEntrepriseList', default: () => [] },
        // Kept as plain objects array (no Map converter required at this time)
        mapDateValidationInventaire: { key: 'mapDateValidationInventaire', default: () => [] },
        codeOCCT: { key: 'codeOCCT', optional: true, default: '' },
        complementPoPdfVer: { key: 'complementPoPdfVer', converter: new (ArrayClassConverterFactory.build(ComplementPoPdfVer))(), default: () => [] }
    };

    idEntrepriseList: number[];
    mapDateValidationInventaire: Map<number, Date>[];
    codeOCCT: string;
    complementPoPdfVer: ComplementPoPdfVer[];
}
